import { createFileRoute } from '@tanstack/react-router';

import CategoryForm from './-components/CategoryForm';

export const Route = createFileRoute('/_authenticated/categories/new')({
    component: CategoryForm,
});
